import * as React from 'react'

import { Box, Button, Spinner, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import Promotion from 'modules/ats/store/models/Promotion'

import JobBoardCard, { ProviderComponentProps } from '../JobBoardCard'
import JobTargetLogo from './job-target-logo.png'

export const JobTarget = observer(({ job }: ProviderComponentProps) => {
  const [closeModal, toggleCloseModal] = React.useState(false)

  const {
    success,
    value,
    performAction: promoteJob,
    running,
  } = useAsyncAction(
    async () => {
      toggleCloseModal(false)

      return Promotion.create({
        ats_job_posting_id: job.id,
        provider: 'job_target',
      })
    },
    { errorFlash: true, successFlash: false }
  )

  const action = (
    <Button
      onClick={promoteJob}
      disabled={!job.isPublished}
      type="secondary"
      iconName="external link"
    >
      {i18n.t('ats.job_details.promotion.job_boards.buttons.promote_button')}
    </Button>
  )

  const openModal = !closeModal && (running || success)
  const iframeProps = success ? (value as Promotion).attributes.data : {}

  return (
    <JobBoardCard
      title="JobTarget"
      description={i18n.t('ats.job_details.promotion.job_target.description')}
      websiteUrl="https://jobtarget.com"
      logo={JobTargetLogo}
      action={action}
    >
      {openModal && (
        <Modal.Sidebar title="JobTarget" onClose={() => toggleCloseModal(true)} {...iframeProps}>
          <Box justifyContent="center" style={{ height: 'calc(100vh - 104px)' }}>
            <Box alignItems="center" gap="s8" width="full" padding="s240" textAlign="center">
              <Spinner />
              <Text.Header2>
                {i18n.t('ats.job_details.promotion.job_target.loading_title')}
              </Text.Header2>
              <Text.Normal color="grey600" size="200">
                {i18n.t('ats.job_details.promotion.job_target.loading_description')}
              </Text.Normal>
            </Box>
          </Box>
        </Modal.Sidebar>
      )}
    </JobBoardCard>
  )
})
